export default {
    guidances: [],
    coGuidances: []
}